import * as React from 'react';
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Stack from '@mui/material/Stack';
import { useEffect, useCallback, useState } from 'react';
import {
    Box, Typography
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import { ReactComponent as DotMenu } from "../../../../assets/icons/dot-menu.svg";
import { ReactComponent as EditIcon } from "../../../../assets/icons/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/icons/delete.svg";
import { ReactComponent as Duplicate } from "../../../../assets/icons/duplicate.svg";
import { ReactComponent as CurrentEmployees } from "../../../../assets/icons/currentEmployees.svg";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";

const useStyles = makeStyles({
    btn: {
        fontSize: "18px !important",
        lineHeight: "24.59px !important",
        textDecoration: "underline !important",
        '& > svg': {
            marginLeft: "10px",
            marginBottom: "-2px",
        }
    },
    fillBlack: {
        width: "24px",
        height: "24px",
        '& > path': {
            fill: '#404349'
        },
        '& g > path': {
            fill: '#404349'
        },
    },
    fillBlackD: {
        width: "24px",
        height: "24px",
    },
});

const styles = {
    td: {
        fontSize: "18px",
        lineHeight: "24.59px",
        textDecoration: "underline",
        '& > svg': {
            marginLeft: "10px",
            marginBottom: "-2px",
        }
    },
    iconBox: {
        width: "24px",
        height: "24px",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        marginRight: "12px"
    },
};

const DotMenus = (props) => {
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);
    const classes = useStyles();
    const { active, linkGoToManage, linkGoToEdit, adjust, serial, del } = props;
    const [itemDel, setItemDel] = React.useState("");
    // const [anchorEl, setAnchorEl] = React.useState(null);
    // const open = Boolean(anchorEl);
    const dispatch = useDispatch();
    const Planning = useSelector((state) => state.Planning);
    // useEffect(() => {
    //     setOpen(false);
    // status(false)
    // }, [closeMenu]);
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
        // status((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
        // status(false)
    };
    const handleDel = (data) => {
        if (data === "del") {
            // onDel(row)
        }
    }

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
            // status(false)
        } else if (event.key === 'Escape') {
            setOpen(false);
            // status(false)
        }
    }

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, [open]);

    const { t } = useTranslation()
    const onDeletePress = (evt, data) => {
        setItemDel(serial)
        handleConfirmDeleteDialog(true)
    }
    const adds = (value) => {
        // add(value)
    };
    let editAcc = () => {
        // onEdit();
    }
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    const [isSuccessDeleteDialogOpen, openSuccessDeleteDialog] = React.useState(false);
    const [isConfirmDeleteDialogOpen, openConfirmDeleteDialog] = React.useState(false);
    const handleConfirmDeleteDialog = (val) => {
        openConfirmDeleteDialog(val);
    };
    const handleConfirmDeleteList = () => {
        openConfirmDeleteDialog(false)
        del(serial)
    };
    const openNewTab = (val) => {
        const newWindow = window.open(val, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }
    // const handleDeleteClick = React.useCallback((e, data) => {
    //     e.stopPropagation();
    //     e.preventDefault();
    //     handleConfirmDeleteDialog(true, data)
    //   }, []);
    return (
        <Stack direction="row" spacing={2}>
            <DotMenu
                ref={anchorRef}
                id="composition-button"
                style={{ cursor: "pointer", "z-index": "1" }}
                onClick={handleToggle}
            />
            <Popper
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                placement="bottom-start"
                transition
                disablePortal
                style={{ "z-index": "2" }}
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin:
                                placement === 'bottom-start' ? 'left top' : 'left bottom',
                        }}
                    >
                        <Paper sx={{ "margin-top": "5px !important" }}>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList
                                    autoFocusItem={open}
                                    id="composition-menu"
                                    aria-labelledby="composition-button"
                                    onKeyDown={handleListKeyDown}
                                    sx={{ padding: "16px 0" }}
                                    disabledItemsFocusable={true}
                                >
                                    <MenuItem onClick={() => openNewTab('/admin/current-employees-role/' + serial)} display="flex" sx={{ padding: "8px 24px" }}>
                                        <Box style={styles.iconBox}>
                                            <CurrentEmployees class={`${classes.fillBlackD}`} />
                                        </Box>
                                        <Typography fontSize={18} lineHeight="24px" fontWeight="400" color="#404349">
                                            {t('admin.label.currentEmployees')}
                                        </Typography>
                                    </MenuItem>
                                    <MenuItem onClick={() => clickLink('/admin/security/duplicate-role-permission/' + serial)} display="flex" sx={{ padding: "8px 24px" }}>
                                        <Box style={styles.iconBox}>
                                            <Duplicate class={`${classes.fillBlackD}`} />
                                        </Box>
                                        <Typography fontSize={18} lineHeight="24px" fontWeight="400" color="#404349">
                                            {t('security.duplicate')}
                                        </Typography>
                                    </MenuItem>
                                    {/* {adjust === false ?
                                        <MenuItem disabled>
                                            <Box style={styles.iconBox}>
                                                <EditIcon class={`${classes.fillBlack}`} />
                                            </Box>
                                            {t('label.edit')}
                                        </MenuItem>
                                        : */}
                                    <MenuItem onClick={() => clickLink('/admin/security/edit-role-permission/' + serial)} display="flex" sx={{ padding: "8px 24px" }}>
                                        <Box style={styles.iconBox}>
                                            <EditIcon class={`${classes.fillBlack}`} />
                                        </Box>
                                        <Typography fontSize={18} lineHeight="24px" fontWeight="400" color="#404349" >
                                            {t('label.edit')}
                                        </Typography>
                                    </MenuItem>
                                    {active === "active" ?
                                        <MenuItem disabled display="flex" sx={{ padding: "8px 24px" }}>
                                            <Box style={styles.iconBox} >
                                                <DeleteIcon class={`${classes.fillBlack}`} />
                                            </Box>
                                            <Typography fontSize={18} lineHeight="24px" fontWeight="400" color="#404349" >
                                                {t('label.delete')}
                                            </Typography>
                                        </MenuItem>
                                        :
                                        <MenuItem onClick={() => onDeletePress()} display="flex" sx={{ padding: "8px 24px" }}>
                                            <Box style={styles.iconBox} >
                                                <DeleteIcon class={`${classes.fillBlack}`} />
                                            </Box>
                                            <Typography fontSize={18} lineHeight="24px" fontWeight="400" color="#404349" >
                                                {t('label.delete')}
                                            </Typography>
                                        </MenuItem>
                                    }
                                </MenuList>
                            </ClickAwayListener>
                            <ConfirmDialog
                                open={isConfirmDeleteDialogOpen}
                                trash={true}
                                doConfirm={handleConfirmDeleteList}
                                setValue={handleConfirmDeleteDialog}
                                title={t('label.confirmationofDeletion')}
                                text={t('security.deletedConfirmation')}
                            />
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </Stack >
    );
}

export default DotMenus;